import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";
import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../Base/Components/Loader/Loader";
import Card from "../../../Base/Components/Card/Card";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { useForm } from "../../../Base/Hooks/useForm";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Base/Services/ToastService";
import { obtenerUnits } from "../../../Base/API/Global/UnidadesMedida/UnitRequests";
import { getUsuariosActivos } from "../../../Base/API/IT/Users/UserRequests";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

// ------------------- CONSULTAS A LA API---------------------------
import { EditarOrdenVenta, EliminarOrdenVentaDet, getDetallesOrdenPorId, getDetallesOrdenPorNo, getEncabezadoOrdenPorId, getEncabezadoOrdenPorNo, GuardarOrdenVenta, LiberarOrdenVenta, obtenerNoOrden } from "../../../API/Ventas/SalesOrdersRequest";
import { getCustomers } from "../../../API/Compras/Customers/CustomerRequests";
import { getCustomersDetailsPorCustomer } from "../../../API/Compras/Customers/CustomerDetails/CustomerDetailsRequest";
import { getTerms } from "../../../API/Compras/Terms/TermsRequest";
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { getTasaCambio } from "../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getYarn } from "../../../API/Desarrollo/DesarrolloRequest";

import SalesOrderReporte from "./SalesOrderReporte";

const SalesOrdersCRUD = ({
  showDialog,
  setShowDialog,
  selectedEnc,
  setSelectedEnc,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [clientesDetails, setClientesDetails] = useState([]);
  const [terminosEnvio, setTerminosEnvio] = useState([]);
  const [terminosVenta, setTerminosVenta] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tasaC, setTasaC] = useState([]);
  const [yarns, setYarns] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const [liberado, setLiberado] = useState(false);
  const [users, setUsers] = useState(true);
  const [hiddenliberar, setHiddenLiberar] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(63));
  const [Languaje, setLanguaje] = useState("es");
  const [showDialogReporte, setShowDialogReporte] = useState(false);

  const initialValues = {
    IdSalesOrderEnc: -1,
    CustomerOrder: "",
    Comentario: "",
  };

  const { values, setValues, handleInputChange, resetForm } =useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    setSelected([]);
    setLanguaje("es");

    const clientesTempo = await getCustomers();
    setClientes(clientesTempo);

    const terminosTempo = await getTerms();

    const terminosVenta = terminosTempo.map((t) => ({
      IdTerminoVenta: t.IdTerm,
      TerminoVenta: t.Term,
    }));

    const terminosEnvio = terminosTempo.map((t) => ({
      IdTerminoEnvio: t.IdTerm,
      TerminoEnvio: t.Term,
    }));

    setTerminosVenta(terminosVenta);
    setTerminosEnvio(terminosEnvio);

    const estadosTempo = await getEstadosCategory("Sales");
    setEstados(estadosTempo);

    const tasaCambioTempo = await getTasaCambio();
    setTasaC(tasaCambioTempo[0]?.TasaCambio);

    const yarnsTempo = await getYarn();
    setYarns(yarnsTempo);

    const unidadesTempo = await obtenerUnits();
    setUnidades(
      unidadesTempo?.filter((i) => i?.IdUnit === 2 || i?.IdUnit === 3)
    );

    const usuariosTempo = await getUsuariosActivos();
    let usuariosFiltrados = usuariosTempo?.filter(
      (i) => i?.IdRol === 26 || i.IdUser === userAuth?.IdUser
    );

    const u = usuariosFiltrados.map((t) => ({
      IdUserAgent: t.IdUser,
      UserNameAgent: t.UserName,
    }));
    setUsers(u);

    if (selectedEnc?.length > 0) {
      setHabilitar(false);
      let IdSalesOrderEnc = selectedEnc[0]?.IdSalesOrderEnc;
      const encabezadoTempo = await getEncabezadoOrdenPorId(IdSalesOrderEnc);
      setValues({
        ...encabezadoTempo[0],
        DateCreateStr: new Date(encabezadoTempo[0]?.DateCreateStr),
      });
      setLiberado(encabezadoTempo[0]?.IdStatus === 106 ? true : false);
      const detallesTempo = await getDetallesOrdenPorId(IdSalesOrderEnc);
      setDetalles(detallesTempo);
    } else {
      const numeroOrdenTempo = await obtenerNoOrden();
      const usuario = u.find((us) => us.IdUserAgent === userAuth?.IdUser);
      const estadoInicial = estadosTempo.find((i) => i?.IdStatus === 102);

      setValues({
        ...initialValues,
        IdStatus: estadoInicial,
        StatusName: estadoInicial,
        NoOrden: numeroOrdenTempo[0]?.NoOrden,
        UserNameAgent: usuario,
        IdUserAgent: usuario,
        DateCreateStr: new Date(),
      });
      setDetalles([]);
    }

    setLoading(false);
  };

  const BuscarOrden = async() => {
    const encabezadoTempo = await getEncabezadoOrdenPorNo(values?.NoOrden);
    if(encabezadoTempo.length <= 0){
      toastShow(toast, 'error', 'Error', 'No se encontro la orden de venta.')
      getValoresIniciales()
    }else{
      const detallesTempo = await getDetallesOrdenPorNo(values?.NoOrden);
      setValues({
        ...encabezadoTempo[0],
        DateCreateStr: new Date(encabezadoTempo[0]?.DateCreateStr),
      });
      setLiberado(encabezadoTempo[0]?.IdStatus === 106 ? true : false);
      setDetalles(detallesTempo);
      setHabilitar(false)
      setSelectedEnc(encabezadoTempo)
    }
  }

  const getNuevaNota = async () => {
    setLoading(true);
    setSelectedEnc([]);
    setHabilitar(true);

    const numeroOrdenTempo = await obtenerNoOrden();
    setValues({
      ...initialValues,
      IdStatus: 102,
      StatusName: "Creado",
      NoOrden: numeroOrdenTempo[0]?.NoOrden,
      UserNameAgent: userAuth?.UserName,
      IdUserAgent: userAuth?.IdUser,
      DateCreateStr: new Date(),
    });
    setDetalles([]);

    setLoading(false);
  };

  const agregarNuevaFila = () => {
    let newRowData = [...detalles];
    const newData = {
      IdSalesOrderDet: Math.floor(-(detalles.length + 1) * Math.random() * 1000),
      IdSalesOrderEnc: values?.IdSalesOrderEnc,
      DateCreate: new Date(),
      IdYarnTitle: null,
      Yarn: "",
      ExportDate: null,
      IdUnit: null,
      UnitName: "",
      Comentario: "",
      PrecioL: 0,
      PrecioD: 0,
      SubTotalL: 0,
      SubTotalD: 0,
      Kgs: 0,
      Yds: 0,
      Lbs: 0,
      Quantity: 0,
      TasaCambio: tasaC,
      IdUserEdit: userAuth?.IdUser,
      IdUserCreate: userAuth?.IdUser,
      IdStatus: 102,
      StatusName: "Creado",
    };
    newRowData.push(newData);
    setDetalles(newRowData);
  };

  const verificarCampos = () => {
    let err = false;

    if (!values?.CustomerOrder) {
      err = true;
      toastShow(toast, "error", "Error", "Orden de cliente es requerida.");
      return;
    }
    if (!values?.CustomerName && !values?.IdCustomer) {
      err = true;
      toastShow(toast, "error", "Error", "Cliente es requerido.");
      return;
    }
    if (!values?.TerminoEnvio && !values?.IdTerminoEnvio) {
      err = true;
      toastShow(toast, "error", "Error", "Término de Envío es requerido.");
      return;
    }

    if (detalles.length > 0) {
      detalles.forEach((l) => {
        if (!l.IdYarnTitle) {
          toastShow(
            toast,
            "error",
            "Error",
            "Debe seleccionar el hilo en todos los detalles"
          );
          err = true;
          return;
        }
      });
      detalles.forEach((l) => {
        if (!l.ExportDate) {
          toastShow(
            toast,
            "error",
            "Error",
            "Debe seleccionar la fecha de exportación en todos los detalles"
          );
          err = true;
          return;
        }
      });
      detalles.forEach((l) => {
        if (!l.IdUnit) {
          toastShow(
            toast,
            "error",
            "Error",
            "Debe seleccionar la unidad en todos los detalles"
          );
          err = true;
          return;
        }
      });
      detalles.forEach((l) => {
        console.log(l.Quantity);
        if (l.Quantity <= 0) {
          toastShow(
            toast,
            "error",
            "Error",
            "Debe agregar una cantidad válida en todos los detalles"
          );
          err = true;
          return;
        }
      });
    } else {
      err = true;
      toastShow(
        toast,
        "error",
        "Error",
        "Agregue al menos un detalle de orden."
      );
      return;
    }

    return !err;
  };

  const guardarInformacion = async () => {
    if (verificarCampos()) {
      const encabezado = {
        // ...values,
        IdSalesOrderEnc: values?.IdSalesOrderEnc,
        CustomerOrder: values?.CustomerOrder,
        IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
        IdCustomer: values?.CustomerName?.IdCustomer || values?.IdCustomer,
        IdCustomerDetails:
          values?.CompanyName?.IdCustomerDetails || values?.IdCustomerDetails,
        IdTerminoEnvio:
          values?.TerminoEnvio?.IdTerminoEnvio || values?.IdTerminoEnvio,
        IdTerminoVenta:
          values?.TerminoVenta?.IdTerminoVenta || values?.IdTerminoVenta,
        Comentario: values?.Comentario,
        IdUserAgent: values?.UserNameAgent?.IdUserAgent || values?.IdUserAgent,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };
      let message = <div>¿Está seguro que desea guardar la información?</div>;
      confirmDialog({
        message: message,
        header: "Guardar Información",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          if (encabezado.IdSalesOrderEnc <= 0) {
            const resp = await GuardarOrdenVenta(encabezado, detalles);
            if (resp[0]?.ESTADO === 1) {
              toastShow(toast, "success", "Guardada", resp[0]?.MENSAJE);
              getInfo();
              getValoresIniciales();
            } else {
              toastShow(
                toast,
                "error",
                "Error",
                "Error al guardar la nota de crédito"
              );
            }
          } else {
            const resp = await EditarOrdenVenta(encabezado, detalles);
            if (resp[0]?.ESTADO === 1) {
              toastShow(toast, "success", "Editada", resp[0]?.MENSAJE);
              setTimeout(() => {
                setLoading(false);
              }, 500);
              getInfo();
              getValoresIniciales();
            } else {
              toastShow(
                toast,
                "error",
                "Error",
                "Error al editar la nota de crédito"
              );
            }
          }
          setLoading(false);
        },
        reject: () => {},
      });
    }
  };

  const calcularCantidades = (data) => {
    if (data.newValue) {
      let det = data.data;
      const cantidad = parseFloat(data.newValue);
      const unidad = det.IdUnit;

      if (unidad) {
        det.Quantity = cantidad;

        let Kgs = 0,
          Lbs = 0,
          Yds = 0;

        switch (unidad) {
          case 2: // Kg
            Kgs = cantidad;
            Lbs = cantidad * 2.20462;
            Yds = cantidad * 1.09361;
            break;
          case 3: // Lb
            Lbs = cantidad;
            Kgs = cantidad * 0.453592;
            Yds = cantidad * 0.496;
            break;
          case 9: // Yds
            Yds = cantidad;
            Kgs = cantidad * 0.9144;
            Lbs = cantidad * 2.016;
            break;
          default:
            break;
        }

        det.Kgs = parseFloat(Kgs.toFixed(2));
        det.Lbs = parseFloat(Lbs.toFixed(2));
        det.Yds = parseFloat(Yds.toFixed(2));

        // Calcular SubTotales
        const tasa = parseFloat(det.TasaCambio || 0);
        const precioL = parseFloat(det.PrecioL || 0);
        const precioD = parseFloat(det.PrecioD || 0);

        if (precioL) {
          det.SubTotalL = +(precioL * cantidad).toFixed(2);
        }

        if (precioD) {
          det.SubTotalD = +(precioD * cantidad).toFixed(2);
        }
      } else {
        toastShow(toast, "warn", "Advertencia", "Agrega la unidad de medida.");
        console.log("Primero debes seleccionar una unidad de medida.");
        det.Quantity = 0;
      }
      const updated = [...detalles];
      const index = updated.findIndex(
        (d) => d.IdSalesOrderDet === det.IdSalesOrderDet
      );
      if (index >= 0) {
        updated[index] = det;
        setDetalles(updated);
      }
    }
  };

  const calcularSubTotales = (data, columna) => {
    if (!data?.data || !data.newValue) return;

    let det = data.data;
    const valor = parseFloat(data.newValue);
    const tasa = parseFloat(det.TasaCambio || 0);
    const cantidad = parseFloat(det.Quantity || 0);

    let updated = { ...det };

    switch (columna) {
      case 1: // TasaCambio modificada
        updated.TasaCambio = valor;
        if (updated.PrecioL) {
          updated.PrecioD = +(updated.PrecioL / valor).toFixed(2);
        } else if (updated.PrecioD) {
          updated.PrecioL = +(updated.PrecioD * valor).toFixed(2);
        }
        break;

      case 2: // PrecioL modificado
        updated.PrecioL = valor;
        if (tasa > 0) {
          updated.PrecioD = +(valor / tasa).toFixed(2);
        }
        break;

      case 3: // PrecioD modificado
        updated.PrecioD = valor;
        if (tasa > 0) {
          updated.PrecioL = +(valor * tasa).toFixed(2);
        }
        break;
    }

    // Calcular subtotales
    updated.SubTotalL = +(updated.PrecioL * cantidad).toFixed(2);
    updated.SubTotalD = +(updated.PrecioD * cantidad).toFixed(2);

    // Actualizar el array de detalles
    const tempo = [...detalles];
    const index = tempo.findIndex(
      (d) => d.IdSalesOrderDet === updated.IdSalesOrderDet
    );
    if (index !== -1) {
      tempo[index] = updated;
      setDetalles(tempo);
    }
  };

  const columns = [
    {
      field: "IdSalesOrderDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      field: "DateCreate",
      header: "Fecha",
      headerEn: "Date",
      body: (rowData) => rowData.DateCreate,
      frozen: true,
      Format: "DateTime",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "Yarn",
      header: "Yarn",
      className: "XXXXlarge",
      minWidth: 500,
      editable: habilitar,
      filter: true,
      value: "IdYarnTitle",
      label: "Yarn",
      items: yarns,
      Format: "AutoComplete",
    },
    {
      field: "ExportDate",
      header: "Fecha de Exportancion",
      headerEn: "Export Date",
      className: "medium",
      Format: "DateDisabled",
      editable: habilitar,
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "large",
      editable: habilitar,
      flex: 1,
      minWidth: 200,
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "small",
      editable: habilitar,
      filter: true,
      value: "IdUnit",
      label: "UnitName",
      items: unidades,
      Format: "AutoComplete",
      onChange: ({ state, data: rowData, oldValue }) => {
        let det = { ...rowData };
        let tempo = [...detalles];

        // Solo recalcula si la unidad cambió
        if (state?.IdUnit !== oldValue?.IdUnit) {
          det.IdUnit = state.IdUnit;
          const cantidad = det.Quantity;
          let Kgs = 0,
            Lbs = 0,
            Yds = 0;

          switch (state.IdUnit) {
            case 2: // Kg
              Kgs = cantidad;
              Lbs = cantidad * 2.20462;
              Yds = cantidad * 1.09361;
              break;
            case 3: // Lb
              Lbs = cantidad;
              Kgs = cantidad * 0.453592;
              Yds = cantidad * 0.496;
              break;
            case 9: // Yds
              Yds = cantidad;
              Kgs = cantidad * 0.9144;
              Lbs = cantidad * 2.016;
              break;
            default:
              break;
          }

          det.Kgs = parseFloat(Kgs.toFixed(2));
          det.Lbs = parseFloat(Lbs.toFixed(2));
          det.Yds = parseFloat(Yds.toFixed(2));

          // Calcular subtotales
          const precioL = parseFloat(det.PrecioL || 0);
          const precioD = parseFloat(det.PrecioD || 0);

          if (precioL) {
            det.SubTotalL = +(precioL * cantidad).toFixed(2);
          }

          if (precioD) {
            det.SubTotalD = +(precioD * cantidad).toFixed(2);
          }

          const index = tempo.findIndex(
            (d) => d.IdSalesOrderDet === det.IdSalesOrderDet
          );
          if (index >= 0) {
            tempo[index] = det;
            setDetalles(tempo);
          }
        }
      },
    },
    // CANTIDADES
    {
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      editable: habilitar,
      onChange: (data) => {
        calcularCantidades(data);
      },
    },
    {
      field: "Kgs",
      header: "Kgs",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    {
      field: "Lbs",
      header: "Lbs",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
    },
    // TOTALES
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      editable: habilitar,
      onChange: (data) => {
        calcularSubTotales(data, 1);
      },
    },
    {
      field: "PrecioL",
      header: "Precio L",
      headerEn: "Price L",
      className: "Xsmall",
      Format: "Currency",
      Frozen: true,
      editable: habilitar,
      alignFrozen: "right",
      onChange: (data) => {
        calcularSubTotales(data, 2);
      },
    },
    {
      field: "PrecioD",
      header: "Precio $",
      headerEn: "Price $",
      className: "Xsmall",
      editable: habilitar,
      Format: "Currency",
      onChange: (data) => {
        calcularSubTotales(data, 3);
      },
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "SubTotalL",
      header: "SubTotal L",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
    {
      field: "SubTotalD",
      header: "SubTotal $",
      className: "Xsmall",
      Format: "Currency",
      Sumary: "sum",
      Frozen: true,
      alignFrozen: "right",
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => {},
  };

  const asignarCliente = async (IdCustomer) => {
    const clientesDetailsTempo = await getCustomersDetailsPorCustomer(IdCustomer);
    setClientesDetails(clientesDetailsTempo);
  };

  const LiberarOrden = async () => {
    confirmDialog({
      message: "¿Está seguro que desea Liberar la orden?",
      header: "Liberar",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        setLoading(true);
        const resp = await LiberarOrdenVenta(
          values?.IdSalesOrderEnc,
          userAuth?.IdUser,
          !liberado
        );
        toastShow(toast, "success", "Editado", "Estado cambiado correctamente");
        setTimeout(() => {
          setLoading(false);
          getValoresIniciales();
        }, 500);
      },
      reject: () => {},
    });
  };

  const EliminarOrden = async () => {
    let dataLiberdada = selected?.find((i) => i?.IdStatus === 106);
    let datos = selected?.filter((i) => i?.IdStatus !== 106);
    if (dataLiberdada) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Algunos detalles seleccionadas no se pueden eliminar, ya estan Liberados."
      );
    }
    if (datos?.length > 0) {
      confirmDialog({
        message: "¿Está seguro que desea eliminar detalles?",
        header: "Eliminar Detalles",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          setLoading(true);
          const datosEnviar = datos.map((s) => ({
            ...s,
            IdSalesOrderDet: s?.IdSalesOrderDet,
            IdUserEdit: userAuth?.IdUser,
            status: 104,
          }));
          for (const item of datosEnviar) {
            await EliminarOrdenVentaDet(
              item.IdSalesOrderDet,
              item.IdUserEdit,
              item?.status
            );
          }
          toastShow(
            toast,
            "success",
            "Eliminado",
            "Detalles eliminados correctamente"
          );
          setLoading(false);
          setSelected([]);
          getInfo();
        },
        reject: () => {},
      });
    }
  };

  useEffect(() => {
    getValoresIniciales(selectedEnc);
  }, [selectedEnc]);

  useEffect(() => {
    let IdCustomer = values?.CustomerName?.IdCustomer || values?.IdCustomer;
    if (IdCustomer) {
      asignarCliente(IdCustomer);
    } else {
      setValues({
        ...values,
      });
    }
  }, [values?.CustomerName?.IdCustomer, values?.IdCustomer]);

  const cerrarDialog = () => {
    if (habilitar) {
      confirmDialog({
        message: "¿Está seguro que desea salir sin guardar?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          setShowDialog(false);
          setSelectedEnc([]);
          resetForm();
          setDetalles([]);
          setHabilitar(true);
          getInfo();
        },
        reject: () => {},
      });
    } else {
      setShowDialog(false);
      setSelectedEnc([]);
      setHabilitar(true);
      getInfo();
    }
  };

  const items = [
    {
      className: "p-componentt",
      label: "Ingles",
      icon: "",
      command: () => {
        setShowDialogReporte(true);
        setSelectedEnc([values]);
        setLanguaje("en");
      },
    },
    {
      label: "Español",
      icon: "",
      command: () => {
        setShowDialogReporte(true);
        setSelectedEnc([values]);
        setLanguaje("es");
      },
    },
  ];

  return (
    <div>
      <Dialog
        visible={showDialog}
        onHide={() => cerrarDialog()}
        header={getLabel(baseLang, "ordenVenta", config.language)}
        style={{ width: "90vw", height: "90vh" }}
        maximizable
        maximized
      >
        <Loader loading={loading} />
        <Toast ref={toast} />

        {/* ENCABEZADO */}
        <div className="d-flex flex-column">
          <Card
            contenido={
              <div className="d-flex">
                <div className="col-12">
                  {/* ------------------------- CAMPOS ----------------------- */}
                  <div className="d-flex flex-wrap align-items-start gap-2 mt-2">
                    {/* No. Orden */}
                    <span className="p-inputgroup " style={{ maxWidth: 233 }}>
                      <span className=" field p-float-label">
                        <InputText
                          id="NoOrden"
                          name="NoOrden"
                          value={values?.NoOrden}
                          onChange={handleInputChange}
                          style={{ fontWeight: "bold" }}
                          onKeyDown={(e) =>
                            e.keyCode === 13 ? BuscarOrden() : null
                          }
                        />
                        <label htmlFor="NoOrden">{getLabel(baseLang, "No. Orden", config.language)}</label>
                      </span>

                      <Button
                        icon="pi pi-search"
                        type="button"
                        className="p-button-info "
                        onClick={() => BuscarOrden()}
                        tooltip="Buscar Orden"
                        tooltipOptions={{ position: "top" }}
                      />
                    </span>

                    <span className=" field p-float-label">
                      <InputText
                        id="CustomerOrder"
                        name="CustomerOrder"
                        value={values?.CustomerOrder}
                        onChange={handleInputChange}
                        disabled={!habilitar}
                      />
                      <label htmlFor="CustomerOrder">{getLabel(baseLang, "OrdenC", config.language)}</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.UserNameAgent}
                      items={users}
                      field={"UserNameAgent"}
                      name={"UserNameAgent"}
                      handleInputChange={handleInputChange}
                      label={getLabel(baseLang, "Agente", config.language)}
                    />

                    <span className="p-float-label">
                      <Calendar
                        id="DateCreateStr"
                        name="DateCreateStr"
                        disabled={true}
                        onChange={(e) => handleInputChange(e, "DateCreateStr")}
                        value={values?.DateCreateStr}
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        showIcon
                      />
                      <label htmlFor="DateCreateStr">{getLabel(baseLang, "Fecha", config.language)}</label>
                    </span>

                    <AutoCompleteDropdown
                      enable={false}
                      value={values?.StatusName}
                      items={estados}
                      field={"StatusName"}
                      name={"StatusName"}
                      handleInputChange={handleInputChange}
                      label={getLabel(baseLang, "estado", config.language)}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.CustomerName}
                      items={clientes}
                      field={"CustomerName"}
                      name={"CustomerName"}
                      handleInputChange={handleInputChange}
                      label={getLabel(baseLang, "Cliente", config.language)}
                    />

                    <AutoCompleteDropdown
                      enable={
                        habilitar &&
                        (!!values?.CustomerName?.IdCustomer ||
                          !!values?.IdCustomerDetails)
                      }
                      value={values?.CompanyName}
                      items={clientesDetails}
                      field={"CompanyName"}
                      name={"CompanyName"}
                      handleInputChange={handleInputChange}
                      label={"Buyer"}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.TerminoEnvio}
                      items={terminosEnvio}
                      field={"TerminoEnvio"}
                      name={"TerminoEnvio"}
                      handleInputChange={handleInputChange}
                      label={getLabel(baseLang, "terminoEnvio", config.language)}
                    />

                    <AutoCompleteDropdown
                      enable={habilitar}
                      value={values?.TerminoVenta}
                      items={terminosVenta}
                      field={"TerminoVenta"}
                      name={"TerminoVenta"}
                      handleInputChange={handleInputChange}
                      label={getLabel(baseLang, "terminoVenta", config.language)}
                    />

                    {/* Comentario */}
                    <span className=" p-float-label d-flex">
                      <InputTextarea
                        disabled={!habilitar}
                        id="Comentario"
                        name="Comentario"
                        value={values?.Comentario}
                        onChange={handleInputChange}
                        cols={81}
                        style={{ height: "3rem" }}
                      />
                      <label htmlFor="Comentario">{getLabel(baseLang, "comentario", config.language)}</label>
                    </span>

                    {hiddenliberar && values?.IdSalesOrderEnc > 0 && (
                      <div className="d-flex" style={{ marginTop: 6 }}>
                        <p className="mx-2 mt-2">Liberardo: </p>
                        <Checkbox
                          style={{ marginTop: 11 }}
                          id="liberado"
                          disabled={!hiddenliberar}
                          name="liberado"
                          checked={liberado}
                          onChange={LiberarOrden}
                        />
                      </div>
                    )}
                  </div>

                  {/* --------------------------BOTONES-----------------------  */}
                  <div className="d-flex flex-wrap gap-1 mb-2 mt-3">
                    <Button
                      icon="pi pi-plus"
                      type="button"
                      onClick={() => agregarNuevaFila()}
                      tooltip={getLabel(baseLang, "agregarDetalle", config.language)}
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar}
                    />
                    <Button
                      icon="pi pi-pencil"
                      type="button"
                      onClick={() => setHabilitar(true)}
                      tooltip={getLabel(baseLang, "editar", config.language)}
                      tooltipOptions={{ position: "top" }}
                      disabled={
                        values?.IdSalesOrderEnc <= 0 || values?.IdStatus === 106
                      }
                    />

                    <Button
                      icon="pi pi-save"
                      type="button"
                      onClick={guardarInformacion}
                      tooltip={getLabel(baseLang, "guardar", config.language)}
                      tooltipOptions={{ position: "top" }}
                      disabled={!habilitar || detalles?.length === 0}
                    />

                    <Button
                      icon="pi pi-times"
                      type="button"
                      className="p-button-danger"
                      onClick={() => EliminarOrden()}
                      tooltip={getLabel(baseLang, "eliminar", config.language)}
                      disabled={!habilitar || selected?.length === 0}
                      tooltipOptions={{ position: "top" }}
                    />
                    <Button
                      icon="pi pi-sync"
                      type="button"
                      onClick={() => getValoresIniciales()}
                      tooltip={getLabel(baseLang, "cargar", config.language)}
                      tooltipOptions={{ position: "top" }}
                    />

                    {values?.IdSalesOrderEnc > 0 && (
                      <SplitButton
                        disabled={false}
                        tooltip={getLabel(baseLang, "formato", config.language)}
                        icon="pi pi-print"
                        onClick={(e) => {
                          setShowDialogReporte(true);
                          setLanguaje("es");
                        }}
                        model={items}
                      />
                    )}

                    <Button
                      icon="pi pi-book"
                      type="button"
                      onClick={() => {
                        confirmDialog({
                          message: getLabel(baseLang, "crearNuevaOrdenConsulta", config.language),
                          header: getLabel(baseLang, "crearNuevaOrden", config.language),
                          icon: "pi pi-exclamation-triangle",
                          accept: () => {
                            getNuevaNota();
                          },
                        });
                      }}
                      tooltip={getLabel(baseLang, "nuevaOrden", config.language)}
                      tooltipOptions={{ position: "top" }}
                    />
                  </div>
                </div>
              </div>
            }
          />
        </div>

        {/* DETALLES */}
        <Card
          contenido={
            <div style={{ height: "65vh" }}>
              <AgGrid table={table} />
            </div>
          }
        />
      </Dialog>

      {showDialogReporte && (
        <SalesOrderReporte
          showDialogReporte={showDialogReporte}
          setShowDialogReporte={setShowDialogReporte}
          selectedEnc={selectedEnc}
          getInfo={() => {}}
          Language={Languaje}
        />
      )}
    </div>
  );
};

export default SalesOrdersCRUD;
